import React, { useEffect } from 'react';
import { SystemTypesHero } from '../components/system-types/SystemTypesHero';
import { SystemComparisonSection } from '../components/system-types/SystemComparisonSection';
import { DecisionGuideSection } from '../components/system-types/DecisionGuideSection';
import { ControlsAutomationSection } from '../components/system-types/ControlsAutomationSection';
import { ObjectionsSection } from '../components/system-types/ObjectionsSection';
import { SystemTypesCTA } from '../components/system-types/SystemTypesCTA';
export function SystemTypesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background font-sans antialiased" data-id="element-1291">
      <main data-id="element-1292">
        <SystemTypesHero data-id="element-1293" />
        <SystemComparisonSection data-id="element-1294" />
        <DecisionGuideSection data-id="element-1295" />
        <ControlsAutomationSection data-id="element-1296" />
        <ObjectionsSection data-id="element-1297" />
        <SystemTypesCTA data-id="element-1298" />
      </main>
    </div>;
}